import {API_HOST, API_URL} from "../../constants/axios";
import axios from "axios";


export const listCoupons = async () => {
    return await axios.get(API_HOST + API_URL.ADVANCED_COUPONS)
}

export const paymentReady = async (orderId, ordererName, userId, amount, orderList, usePoint) => {
    const res = await axios.post(API_HOST + API_URL.ADVANCED_COUPON_READY, {
        orderId, ordererName, userId, amount, orderList, usePoint
    })

    return res;
}

export const getCouponUser = async (code) => {
    return await axios.get(API_HOST + API_URL.ADVANCED_COUPON_USER + `?code=${code}`)
}

export const postRefundCoupon = async (couponId) => {
    return await axios.post(API_HOST + API_URL.ADVANCED_COUPON_REFUND, {
        couponId
    })
}

export const getCouponInfo = async (id, code) => {
    return await axios.get(API_HOST + API_URL.ADVANCED_COUPON_INFO + `?id=${id}&code=${code}`)
}

export const usedCoupon = async (couponId) => {
    return await axios.post(API_HOST + API_URL.ADVANCED_COUPON_USED, {
        couponId
    })
}